export const styles = {
  activityContainer: {
    marginTop: 25,
    fontSize: 13,
  },
  semibold: {
    fontWeight: 600,
    WebkitFontSmoothing: "antialiased",
    color: "#494848",
  },
  bold: {
    fontWeight: 800,
    WebkitFontSmoothing: "antialiased",
    color: "#494848",
  },
  activityCont: {
    border: "1px solid #BCBCBC",
    minHeight: 60,
    float: "left",
    width: "calc(100% - 45px)",
    padding: "3px 10px 3px 10px",
  },
  iconCont: {
    minHeight: 60,
    float: "left",
    width: 40,
    marginRight: 5,
  },
  iconCircle: {
    position: "relative",
    width: 35,
    height: 35,
    borderRadius: 100,
    border: "1px solid #BCBCBC",
    marginTop: 12,
  },
  icon: {
    position: "absolute",
    top: 10,
    left: 10,
    fontSize: 13,
    color: "#BCBCBC",
  },
  title: {
    fontSize: 13,
    fontWeight: 800,
    margin: "0 0 2px 0",
  },
  date: {
    fontSize: 13,
    margin: 0,
    color: "grey",
  },
  diffContainer: {
    display: "inline-block",
    padding: 5,
    fontSize: 13,
    wordBreak: "break-word",
  },
  diffField: {
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "monospace",
    WebkitFontSmoothing: "antialiased",
  },
  diffItem: {
    padding: "0px 3px",
    border: "1px solid #e4e4e4",
    background: "white",
    backgroundColor: "#f7f7f7",
    fontFamily: "monospace",
  },
  bodyContainer: {
    maxHeight: 200,
    overflowY: "scroll",
    margin: "7px 0 15px 0",
  },
} as const;
